<template>
  <div class="product">
    <div class="banner">
<!--      <img src="/static/images/product/banner.png" alt="">-->
<!--      <img src="https://s1.ax1x.com/2022/04/01/qh4vB8.png" alt="banner">-->
      <img :src="img_src.banner" alt="banner">

    </div>
    <div class="content">
      <div class="product-title">
        <p>产 品 展 示</p>
        <div class="line">
          <span class="span1"></span>
          <span class="span2">Prodaction  Exhibition</span>
          <span class="span1"></span>
        </div>
      </div>

      <div class="product-list">
        <div class="product-row">
          <div class="col">
            <div class="img-box right">
<!--              <img src="/static/images/product/product1.png" alt="product">-->
<!--              <img src="https://s1.ax1x.com/2022/04/01/qh47hd.png" alt="product1">-->
              <img :src="img_src.product1" alt="product1">
            </div>
            <div class="info-box right">
              <div class="info-box-number">HN-200F</div>
              <div class="info-box2-message">
                <div class="message1 height1">
			          	<div class="name1">设备尺寸</div>
			          	<div class="particulars1">主机长79cm*宽59cm*高105cm; 超声波身高体重秤长31cm*宽50m*高240m重量约45kg</div>
			          </div>
			          <div class="message2 height2">
			          	<div class="name2">设备特点</div>
			          	<div class="particulars2">推车式设计:可移动灵活方便:标配动脉硬化检测功能，即时打印体检报告及健康促进建议数据支持有线及无线网络传输:支持刷二代居民身份证或IC卡可拓展指纹和人脸识别。</div>
			          </div>
			          <div class="message2 height3">
			          	<div class="name2">体检功能</div>
			          	<div class="particulars2">标配功能:自助建档、电子问卷、动脉硬化、身高、体重、BMI、腰臀比、脉率、血压、血糖、血氧、尿酸、总胆困醇、人体代谢率，水分含量，脂肪含量、体温、12导心电。可拓展功能:电子宣教、骨密度、肺功能，尿液分析、中医体质辨识，血脂四项、糖化血红蛋白等。(具体功能购买时请与业务人员核对)</div>
			          </div>
			          <div class="message1 height1">
			          	<div class="name1">应用场所</div>
			          	<div class="particulars1">社区医院、乡镇卫生院，养老机构、员工休息区、药房、健康管理机构、营养品专卖点，保险公司等。</div>
			          </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="img-box left">
<!--              <img src="/static/images/product/product2.png" alt="product">-->
<!--              <img src="https://s1.ax1x.com/2022/04/01/qh4Lct.png" alt="product">-->
              <img :src="img_src.product2" alt="product2">
            </div>
            <div class="info-box">
              <div class="info-box-number">HN-501全能机</div>
              <div class="info-box2-message">
                <div class="message1 height1">
			          	<div class="name1">设备尺寸</div>
			          	<div class="particulars1">长250cm*宽130cm*高240cm*重约200kg</div>
			          </div>
			          <div class="message2 height2">
			          	<div class="name2">设备特点</div>
			          	<div class="particulars2">功能国内最全，外观高档大气、医疗科技感十足，支持四人在线使用分区体检，体检效率为普通单人机的4倍，节省等候人员时间;可移动灵活方便即时打印体检报告及健康促进建议数据支持有线及无线网络传输:支持刷二代居民身份证或IC卡，可拓展指纹和人脸识别。</div>
			          </div>
			          <div class="message2 height3">
			          	<div class="name2">体检功能</div>
			          	<div class="particulars2">标配功能:自助建档、电子问卷、远程医疗语音系统、电子宣教、骨密度、肺功能、电子视力、尿液分析、中医体质辨识、血脂四项、糖化血红蛋白，身高，体重，BMI、 腰臀比脉车、血压，血糖、血氧、尿酸、总胆固醇、人体代谢率、水分含量，脂肪含量、12导心电，体温。可拓展功能: B超、动脉硬化、血生化等。(具体功能购买时请与业务人员核对)</div>
			          </div>
			          <div class="message1 height1">
			          	<div class="name1">应用场所</div>
			          	<div class="particulars1">医院、杜康中心、养老机构、远程医疗服务区、展厅、研究院、大学、楼盘等。</div>
			          </div>
              </div>
            </div>
          </div>
        </div>
        <div class="product-row">
          <div class="col">
            <div class="img-box">
<!--              <img src="/static/images/product/product3.png" alt="product">-->
<!--              <img src="https://s1.ax1x.com/2022/04/01/qh4b9A.png" alt="product">-->
              <img :src="img_src.product3" alt="product3">
            </div>
            <div class="info-box right">
              <div class="info-box-number">HN-80</div>
              <div class="info-box2-message">
                <div class="message1 height1">
			          	<div class="name1">设备尺寸</div>
			          	<div class="particulars1">主机长150cm*宽60cm*高1 10cm;身高体重秤长38cm*宽58cm*高240cm;重量约80kg</div>
			          </div>
			          <div class="message2 height2">
			          	<div class="name2">设备特点</div>
			          	<div class="particulars2">工作台环抱式设计，方便管理人员与体检人员交互:可移动灵活方便:即时打印体检报告及健康促进建议数据支持有线及无线网络传输:支持刷二代居民身份证或IC卡可拓展指纹和人脸识别。</div>
			          </div>
			          <div class="message2 height3">
			          	<div class="name2">体检功能</div>
			          	<div class="particulars2">标配功能:自助建档、电子问卷，身高、体重、BMI.腰臀比。脉率，血压、血糖、血氧，尿酸、总胆固醇、人体代谢率，水分含量，脂肪含量，12导心电。体温。可拓展功能: B超、动脉硬化、电子宣教、骨密度、肺功能、尿液分析、中医体质辨识、血脂四项。糖化血红蛋白等、远程医疗语音系统、血生化等。(具体功能购买时请与业务人员核对)</div>
			          </div>
			          <div class="message1 height1">
			          	<div class="name1">应用场所</div>
			          	<div class="particulars1">社区医院、乡镇卫生院，养老机构、员工休息区、旗舰药房，健康管理机构等。</div>
			          </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="img-box left">
<!--              <img src="/static/images/product/product4.png" alt="product">-->
<!--              <img src="https://s1.ax1x.com/2022/04/01/qh4q1I.png" alt="product">-->
              <img :src="img_src.product4" alt="product4">
            </div>
            <div class="info-box">
              <div class="info-box-number">HN-300H</div>
              <div class="info-box2-message">
                <div class="message1 height1">
			          	<div class="name1">设备尺寸</div>
			          	<div class="particulars1">长230cm*宽130cm*高240cm*重约130kg</div>
			          </div>
			          <div class="message2 height2">
			          	<div class="name2">设备特点</div>
			          	<div class="particulars2">外观高档大气、医疗科技感十足。支持四人在线使用分区体检。体检效率为普通单人机的4倍，节省等候人员时间;可移动灵活方便:即时打印体检报告及健康促进建议数据支持有线及无线网络传输:支持刷二代居民身份证或IC卡可拓展指纹和人脸识别。</div>
			          </div>
			          <div class="message2 height3">
			          	<div class="name2">体检功能</div>
			          	<div class="particulars2">标配功能:自助建档、电子问卷、身高、体重， BMI、 腰臀比、脉率、血压、血糖、血氧、尿酸、总胆固醇、人体代谢率、水分含量、脂肪含量、12导心电。可拓展功能:体温、B超、动脉硬化。电子宣教、骨密度，肺功能，尿液分析、中医体质辨识、血脂四项，糖化血红蛋白等、远程医疗语音系统、血生化等。(具体功能购买时请与业务人员核对)</div>
			          </div>
			          <div class="message1 height1">
			          	<div class="name1">应用场所</div>
			          	<div class="particulars1">医院、社康中心、养老机构、远程医疗服务区、展厅、研究院、大学、楼盘等。</div>
			          </div>
              </div>
            </div>
          </div>
        </div>
        <div class="product-row">
          <div class="col">
            <div class="img-box">
<!--              <img src="/static/images/product/product5.png" alt="product">-->
<!--              <img src="https://s1.ax1x.com/2022/04/01/qh4OjP.png" alt="product">-->
              <img :src="img_src.product5" alt="product5">
            </div>
            <div class="info-box right">
              <div class="info-box-number">HN-300F</div>
              <div class="info-box2-message">
                <div class="message1 height1">
			          	<div class="name1">设备尺寸</div>
			          	<div class="particulars1">长185cm*宽1 10cm*高245cm*重约100kg</div>
			          </div>
			          <div class="message2 height2">
			          	<div class="name2">设备特点</div>
			          	<div class="particulars2">外观高档大气。医疗科技感十足，支持双人在线使用分区体检，体检效率为普通单人机的2倍，节省等候人员时间:可移动灵活方便:即时打印体检报告及健康促进建议数据支持有线及无线网络传输;支持刷二代居民身份证或C卡可拓展指纹和人脸识别。</div>
			          </div>
			          <div class="message2 height3">
			          	<div class="name2">体检功能</div>
			          	<div class="particulars2">标配功能:自助建档、电子问卷、身高、体重，BMI.腰臂比、脉率、血压。血糖、血氧、尿酸，总胆固醇、人体代谢率、水分含量、脂肪含量、12号心电，可拓展功能:体温、B超、动脉硬化、电子宣教、骨密度、肺功能、尿液分析、中医体质辨识。血脂四项、糖化血红蛋白等、远程医疗语音系统。血生化等。(具体功能购买时请与业务人员核对)</div>
			          </div>
			          <div class="message1 height1">
			          	<div class="name1">应用场所</div>
			          	<div class="particulars1">社区医院、社康中心、乡镇卫生院。养老机构、员工休息区、楼盘、金融机构等。</div>
			          </div>
              </div>
            </div>
          </div>
          <div class="col product6">
<!--            <img src="/static/images/product/product6.png" alt="roduct">-->
<!--            <img src="https://s1.ax1x.com/2022/04/01/qh4jnf.png" alt="product6">-->
            <img :src="img_src.product6" alt="product6">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      img_src: {
        banner: 'https://s1.ax1x.com/2022/04/06/qXoXx1.png',
        product1: 'https://s1.ax1x.com/2022/04/06/qXoqPJ.png',
        product2: 'https://s1.ax1x.com/2022/04/06/qXoLG9.png',
        product3: 'https://s1.ax1x.com/2022/04/06/qXoH54.png',
        product4: 'https://s1.ax1x.com/2022/04/06/qXo7aF.png',
        product5: 'https://s1.ax1x.com/2022/04/06/qXoO2R.png',
        product6: 'https://s1.ax1x.com/2022/04/06/qXovKx.png',
      }
    }
  }
}
</script>

<style lang="scss" scope>
.product {
  width: 100%;
  height: 100%;
}
.banner {
  height: 500px;
  margin: 0 auto 100px;
  img {
    width: 100%;
    min-width: 1200px;
    height: 500px;
  }
}

.product-title {
  width: 100%;
  text-align: center;
  p {
    font-size: 48px;
    font-weight: bold;
    color: #00A0E9;
    text-align: center;
  }
  .line {
    display: flex;
    justify-content: center;
    align-items: center;
    .span1 {
      width: 104px;
      height: 2px;
      background-color: #00A0E9;
    }
    .span2 {
      font-size: 24px;
      color: #808080;
      margin-right: 30px;
      margin-left: 30px;
    }
  }
}

.product-list {
  margin-top: 26px;
  margin-bottom: 250px;
  .product-row {
    display: flex;
    margin-top: 100px;
    .col {
      flex: 1;
      display: flex;
      .img-box {
        width: 239px;
        text-align: center;
        display: flex;
        align-items: center;
        img {
          max-width: 100%;
        }
      }
      .left {
        padding-left: 15px;
      }
      .right {
        padding-right: 15px;
      }
      .info-box {
        flex: 1;
        .info-box-number {
          width: 70%;
          height: 30px;
          line-height: 30px;
          text-align: center;
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 10px;
          background-color: #dfdcdd;
        }
        .info-box2-message {
          width: 100%;
          height: calc(100% - 40px);
          .message1 {
            display: flex;
            margin-bottom: 1px;
            .name1 {
              flex: 0 0 30%;
              display: flex;
              justify-content: center;
              align-items: center;
              font-weight: bold;
              background-color: #b7b4b8;
            }
            .particulars1 {
              flex: 1;
              display: flex;
              justify-content: center;
              align-items: center;
              padding-left: 10px;
              padding-right: 10px;
              font-size: 12px;
              background-color: #dddddd;
            }
          }
          .message2 {
            display: flex;
            margin-bottom: 1px;
            .name2 {
              flex: 0 0 30%;
              display: flex;
              justify-content: center;
              align-items: center;
              font-weight: bold;
              background-color: #b7b4b8;
            }
            .particulars2 {
              flex: 1;
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 10px;
              font-size: 12px;
              background-color: #dddddd;
            }
          }
        }
      }
    }
    .product6 {
      padding-left: 30px;
      img {
        width: 100%;
      }
    }
    .height1 {
      height: 60px;
    }
    .height2 {
      height: 132px;
    }
    .height3 {
      height: 168px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Product.vue